export default __webpack_public_path__ + "static/icon-corporate-information-87db973ec9a384c0f84bc86e02be8ff5.svg";